import TourDataMapViewController from "./tour_data_map_view_controller"
import ContextMenu from "../admin_controllers/context_menu"
import {showWindowOverlay} from "../helpers/tour_window_overlay"

const POINT_DATA_TYPES = {
    2:  { desc: "景点", color: "blue" },
    1:  { desc: "旅游城市", color: "black" },
    32: { desc: "导游词", color: "#ff6700" },
    4:  { desc: "美食特产", color: "#c084fc" },
    19: { desc: "观景台", color: "#3b82f6" },
    23: { desc: "旅游服务区", color: "#ffe700" },
    30: { desc: "自驾营地", color: "#ff1800" },
}

const SELF_DRIVE_ROUTE_DATA_TYPE = 13

export default class extends TourDataMapViewController {
    connect() {
        super.connect()

        this.initContextMenu()
        this.initPathSimplifier()
        this.initFilterButtons()

        if (!this.dataFilteredValue) {
            this.dataSource = []
            this.fetchAllSelfDriveRoutes()
        }
    }

    initContextMenu() {
        this.mapContextMenu = new ContextMenu()

        this.mapContextMenu.addItem("显示详情", this.showDetail)
        this.mapContextMenu.addItem("显示关联的数据点", this.showAssociatedPoints)
        this.mapContextMenu.addItem("显示5公里范围内的数据点", this.showNearByPoints5KM)
        this.mapContextMenu.addItem("显示10公里范围内的数据点", this.showNearByPoints10KM)
        this.mapContextMenu.addItem("巡航", this.onStartCruise)
    }

    initPointsSimplifier() {
        AMapUI.load(['ui/misc/PointSimplifier'], (PointsSimplifier) => {
            if (!PointsSimplifier.supportCanvas) {
                alert('当前环境不支持 Canvas！')
                return
            }

            let [renderConstructor, renderOptions] = this.getRenderOptions(PointsSimplifier)

            this.pointsSimplifier = new PointsSimplifier({
                map: this.map,
                zIndex: 130,
                autoSetFitView: false,
                compareDataItem: function(a, b, aIndex, bIndex) {
                    return aIndex > bIndex ? -1 : 1;
                },
                getPosition: function(dataItem) {
                    return dataItem.position;
                },
                getHoverTitle: (dataItem, index) => {
                    return dataItem.title
                },
                renderConstructor: renderConstructor,
                renderOptions: renderOptions,
            })

            this.pointsSimplifier.setData(null)

            this.pointsSimplifier.on('pointClick', (event, record) => {
                this.showDialogWithData(record.data.dataType, record.data)
                setTimeout(() => this.mapContextMenu.close(), 100)
            })
        })

        this.pointsData = []
        this.queryedPointsData = []
    }

    getRenderOptions(PointsSimplifier) {
        const renderConstructor = PointsSimplifier.Render.Canvas.GroupStyleRender
        const groupStyleOptions = {}

        for (const dataType in POINT_DATA_TYPES) {
            groupStyleOptions[dataType] = {
                pointStyle: { fillStyle: POINT_DATA_TYPES[dataType].color }
            }
        }

        const renderOptions = {
            getGroupId: function(dataItem, index) {
                return dataItem.dataType
            },
            groupStyleOptions: groupStyleOptions,
        }

        return [renderConstructor, renderOptions]
    }

    initPathSimplifier() {
        AMapUI.load(['ui/misc/PathSimplifier'], (PathSimplifier) => {
            if (!PathSimplifier.supportCanvas) {
                alert('当前环境不支持 Canvas！')
                return
            }

            this.PathSimplifierModule = PathSimplifier

            this.pathSimplifier = new PathSimplifier({
                zIndex: 120,
                map: this.map,
                getPath: (pathData, pathIndex) => {
                    return pathData.path
                },
                getHoverTitle: (pathData, pathIndex, pointIndex) => {
                    const statistics = this.getRouteStatisticsDescById(pathData.id)
                    if (statistics.length > 0) {
                        return `${pathData.title} (${statistics})`
                    } else {
                        return pathData.title
                    }
                },
                renderOptions: {
                    pathLineStyle: {
                        strokeStyle: 'red',
                        lineWidth: 6,
                        dirArrowStyle: true
                    },
                    pathLineHoverStyle: {
                        strokeStyle: '#3e8ed0',
                        lineWidth: 8,
                    },
                    pathLineSelectedStyle: {
                        strokeStyle: '#00d1b2',
                        lineWidth: 6,
                    }
                }
            })

            this.pathSimplifier.setData(this.dataSource)

            this.pathSimplifier.on('pathClick pointClick', (event, info) => {
                const lnglat = event.originalEvent.lnglat
                this.mapContextMenu.open(this.map, lnglat)
            });
        })
    }

    setTitleWithData(dataSource) {
        this.titleElement.innerText = `共${dataSource.length}个`
    }

    initFilterButtons() {
        this.filterButtonsPanel = document.createElement("div")

        let filterButtonsHTML = ""

        for (let dataType in POINT_DATA_TYPES) {
            const object = POINT_DATA_TYPES[dataType]
            const backgroundColor = object.color

            let buttonClass = (backgroundColor === "blue" || backgroundColor === "black") ? "button is-small has-text-white" : "button is-small"

            filterButtonsHTML += `<button class="${buttonClass}" data-data-type="${dataType}" style="background-color:${object.color}">${object.desc}</button>`
        }

        this.filterButtonsPanel.innerHTML = `<div class='box p-3' style='position:absolute;right:20px;top:calc(3.25rem + 20px)'>
                          <div class="is-flex is-flex-direction-column">${filterButtonsHTML}</div></div>`

        this.element.appendChild(this.filterButtonsPanel)

        this.filterButtonsPanel.querySelectorAll("button").forEach((button) => {
            button.addEventListener("click", (event) => {
                event.target.classList.toggle("is-selected")

                if (this.pointsData && this.pointsData.length > 0) {
                    let filteredDataTypes = []

                    this.filterButtonsPanel.querySelectorAll("button.is-selected").forEach((button) => {
                        filteredDataTypes.push(parseInt(button.dataset.dataType))
                    })

                    let filteredData = null

                    if (filteredDataTypes.length > 0) {
                        filteredData = this.pointsData.filter((object) => filteredDataTypes.indexOf(object.dataType) !== -1)
                    } else {
                        filteredData = this.pointsData
                    }

                    this.pointsSimplifier.setData(filteredData)
                    this.setRouteStatisticsWithData(filteredData)
                }
            })
        })
    }

    resetFilterButtons() {
        if (this.filterButtonsPanel) {
            this.filterButtonsPanel.querySelectorAll("button").forEach((button) => {
                button.classList.remove("is-selected")
            })
        }
    }

    showNearPoints(radius) {
        this.showPointsWithUrl(`/tour_data_map_view/self_drive_route_nearby_points?radius=${radius}`)
    }

    showPointsWithUrl(url) {
        this.showLoading(true)

        const data = this.pathSimplifier.getSelectedPathData()
        if (data) {
            let prefix = url.indexOf("?") !== -1 ? "&" : "?"
            url = `${url}${prefix}self_drive_route_id=${data.id}`

            this.fetchData(url, (jsonResult) => {
                let pointsData = []

                for (const key in jsonResult) {
                    const dataType = parseInt(key)
                    const points = jsonResult[dataType]

                    for (const point of points) {
                        pointsData.push({dataType: dataType, id: point.id, title: point.title, position: this.parseLnglat(point.position)})
                    }
                }

                this.setPointsData(pointsData)
                this.setRouteStatisticsWithData(pointsData)
                this.resetFilterButtons()

                this.showLoading(false)
            })
        }
    }

    setRouteStatisticsWithData(pointsData) {
        if (!this.routeStatistics) {
            this.routeStatistics = {}
        }

        const data = this.pathSimplifier.getSelectedPathData()
        if (data) {
            const id = data.id
            this.routeStatistics = { [id]: {} }

            if (pointsData) {
                for (const dataType in POINT_DATA_TYPES) {
                    let count = 0

                    pointsData.forEach((point) => {
                        if (point.dataType == dataType) {
                            count += 1
                        }
                    })

                    if (count > 0) {
                        this.routeStatistics[id][dataType] = count
                    }
                }
            }
        }
    }

    getRouteStatisticsDescById(id) {
        if (this.routeStatistics && this.routeStatistics[id]) {
            const statistics = this.routeStatistics[id]

            let result = ""
            let totalCount = 0

            for (const dataType in statistics) {
                const dataTypeDesc = POINT_DATA_TYPES[dataType].desc
                const count = statistics[dataType]

                totalCount += count
                result += `${dataTypeDesc}:${count} `
            }

            if (totalCount > 0) {
                return `共${totalCount}个数据点 - ${result}`
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    startCruise() {
        if (!this.pathSimplifier)
            return

        this.stopCruise()

        const pathIndex = this.pathSimplifier.getSelectedPathIndex()

        if (pathIndex !== -1) {
            const pathData = this.pathSimplifier.getSelectedPathData()
            let distance = AMap.GeometryUtil.distanceOfLine(pathData.path) / 1000.0

            let speed = distance * 200

            this.pathNavigator = this.pathSimplifier.createPathNavigator(pathIndex, {
                speed: speed,
                pathNavigatorStyle: {
                    width: 16,
                    height: 32,
                    content: this.PathSimplifierModule.Render.Canvas.getImageContent('/car.png', null, null),
                    strokeStyle: null,
                    fillStyle: null
                }
            })

            this.pathNavigator.start()
            this.pathNavigator.on("pause", () => {
                setTimeout(() => {
                    this.stopCruise()
                }, 1000)
            })
        }
    }

    stopCruise() {
        if (this.pathNavigator) {
            this.pathNavigator.destroy()
            this.pathNavigator = null
        }
    }

    onStartCruise = (event) => {
        this.startCruise()
    }

    showDetail = (event) => {
        const data = this.pathSimplifier.getSelectedPathData()
        if (data) {
            this.showDialogWithData(SELF_DRIVE_ROUTE_DATA_TYPE, data)
        }
    }

    showAssociatedPoints = (event) => {
        this.showPointsWithUrl("/tour_data_map_view/self_drive_route_associated_points")
    }

    showNearByPoints5KM = (event) => {
        this.showNearPoints(5000)
    }

    showNearByPoints10KM = (event) => {
        this.showNearPoints(10000)
    }

    onAutocompleteSelect(item) {
        if (item.dataType === SELF_DRIVE_ROUTE_DATA_TYPE) {
            this.onAutocompleteSelectRoute(item)
        } else {
            this.onAutocompleteSelectPoint(item)
        }
    }

    onAutocompleteSelectRoute(item) {
        const index = this.dataSource.findIndex(data => data.id === item.id)

        if (index === -1) {
            this.showLoading(true)

            this.fetchData(`/tour_data_map_view/self_drive_route_path?id=${item.id}`, (path) => {
                if (path && path.length > 0) {
                    this.dataSource.push({id: item.id, title: item.title, path: path})
                    this.pathSimplifier.setData(this.dataSource)

                    this.selectPathIndex(this.dataSource.length - 1)
                    this.setMarkerWithStartPoint(this.dataSource.length - 1)

                    this.setTitleWithData(this.dataSource)
                } else {
                    alert("路线轨迹为空, 无法载入!")
                }

                this.showLoading(false)
            })
        } else {
            this.selectPathIndex(index)
            this.setMarkerWithStartPoint(index)
        }
    }

    onAutocompleteSelectPoint(item) {
        if (item.position && item.position.length === 2) {
            const index = this.queryedPointsData.findIndex(data => data.id === item.id && data.dataType === item["data_type"])

            if (index === -1) {
                this.queryedPointsData.push(item)
            }

            this.selectPathIndex(-1)
            this.setPointsData(this.queryedPointsData)

            this.setMarker(item.position[0], item.position[1])
        }
    }

    setPointsData(pointsData) {
        this.pointsData = pointsData
        this.pointsSimplifier.setData(this.pointsData)
    }

    selectPathIndex(index) {
        this.setPointsData([])
        this.setRouteStatisticsWithData([])
        this.resetFilterButtons()

        this.pathSimplifier.setSelectedPathIndex(index)
    }

    setMarkerWithStartPoint(index) {
        if (index > 0 && index < this.dataSource.length) {
            const path = this.dataSource[index].path

            if (path.length > 0) {
                const point = path[0]
                this.setMarker(point[0], point[1])
            }
        }
    }

    getQueryedDataTypes() {
        const dataTypes = [SELF_DRIVE_ROUTE_DATA_TYPE]
        Object.keys(POINT_DATA_TYPES).forEach((dataType) => dataTypes.push(dataType))

        return dataTypes.join(",")
    }

    async fetchAllSelfDriveRoutes() {
        const fetchData = async (page) => {
            const url = `/self_drive_routes/lite_all.json?all=1&page=${page}`

            const response = await fetch(url)
            if (!response.ok) {
                console.error(`fetchData调用出错: status: ${response.status}, statusText: ${response.statusText}`)
                return 0
            }

            const jsonResult = await response.json()

            this.dataSource = this.dataSource.concat(jsonResult["self_drive_routes"])
            this.pathSimplifier.setData(this.dataSource)
            this.setTitleWithData(this.dataSource)

            return jsonResult["page_count"]
        }

        showWindowOverlay(true)

        const pageCount = await fetchData(1)
        for (let page = 2; page <= pageCount; page++) {
            await fetchData(page)
        }

        showWindowOverlay(false)
    }
}